import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_select = _resolveComponent("form-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "navigation-dropdown-tab",
    style: _normalizeStyle({width: `${_ctx.contentWidth + 20}px`})
  }, [
    _createVNode(_component_form_select, {
      class: "nav-select",
      "model-value": _ctx.options.find(v => v.label === _ctx.activeView?.name),
      options: _ctx.options,
      placeholder: _ctx.activeView?.label || '...',
      type: "select",
      onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeView = $event.value))
    }, null, 8, ["model-value", "options", "placeholder"])
  ], 4))
}